const enableConsole = false;
const enableIphone = false;

window.iphonelog = function(msg) {
  if(!enableConsole && !enableIphone) return;

  if(enableConsole) console.log(msg);

  if(!enableIphone) return;
  const boxId = '__iphone_log_box__';
  let box = document.getElementById(boxId);
  if (!box) {
    box = document.createElement('div');
    box.id = boxId;
    box.style.cssText = 'position:fixed;right:8px;bottom:8px;max-width:90vw;max-height:60vh;overflow:auto;z-index:999999;font:12px/1.4 system-ui; background:#111;color:#fff; padding:8px;border-radius:8px;';
    document.body.appendChild(box);
  }
  const line = document.createElement('div');
  line.style.cssText = 'border-top:1px solid #333;padding-top:4px;margin-top:4px;white-space:pre-wrap;word-break:break-word;';
  line.textContent = `${msg}`;
  box.prepend(line);
}

window.formatError = function(err){
  if (!err) return 'Unknown error';
  if (err instanceof Error) {
    return `${err.name}: ${err.message}\n${err.stack || ''}`;
  }
  try { return typeof err === 'object' ? JSON.stringify(err) : String(err); }
  catch { return String(err); }
}

window.addEventListener('error', (ev) => {
  iphonelog(`window.error: ${ev.message || '(no message)'} @ ${ev.filename || ''}:${ev.lineno || ''}:${ev.colno || ''}`);
}, true);

window.addEventListener('unhandledrejection', (ev) => {
  iphonelog(`unhandledrejection: ${formatError(ev.reason)}`);
});

async function themeComponent(url, isAsync = true, checkDom = false) {
  if (!url || url.trim() === '') {
    iphonelog('themeComponent: URL is empty or undefined', url);
    return;
  }

  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('res-', '').replace('.js', '');
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  window.themeloading = window.themeloading || {};

  if (window[className] || window.themeloading[className]) {
    return;
  }

  if (checkDom && document.querySelector(tagName) == null) {
    return;
  }
  iphonelog(`ℹ️ ${tagName}: Carico componente`);

  window.themeloading[className] = true;

  if (isAsync) {
    import(url).then(() => {
      iphonelog(`✅ ${tagName}: import completato (async)`);
    }).catch(err => {
      iphonelog(`❌ ${tagName}: import FALLITO (async): ${formatError(err)}`);
    }).finally(() => {
      window.themeloading[className] = false;
    });
  } else {
    try {
      await import(url);
      iphonelog(`✅ ${tagName}: import tentato (await)`);
    } catch (err) {
      iphonelog(`❌ ${tagName}: import FALLITO (await): ${formatError(err)}`);
    }
    window.themeloading[className] = false;
  }
}
window.themeComponent = themeComponent;


// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

// attivo i tooltip di bootstrap
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// Gestione checkbox carrello
function initCartCheckboxes() {
  const privacyCheckbox = document.getElementById('privacyCheck');
  const newsletterCheckbox = document.getElementById('newsletterCheck');
  const profilazioneCheckbox = document.getElementById('profilazioneCheck');
  
  if (privacyCheckbox) {
    privacyCheckbox.addEventListener('change', function() {
      if (!this.checked) {
        this.value = '';
      } else {
        this.value = 'accepted';
      }
    });
  }

  if (newsletterCheckbox) {
    const newsletterHidden = document.getElementById('newsletterConsentHidden');
    
    newsletterCheckbox.addEventListener('change', function() {
      if (newsletterHidden) {
        newsletterHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
  
  if (profilazioneCheckbox) {
    const profilingHidden = document.getElementById('profilingConsentHidden');
    
    profilazioneCheckbox.addEventListener('change', function() {
      if (profilingHidden) {
        profilingHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
}

// Inizializza le checkbox del carrello quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCheckboxes);
} else {
  initCartCheckboxes();
}

window.initCartCheckboxes = initCartCheckboxes;
